/* ==========================================================================
   Jab Collective — live seat count (site-wide, one file). No countdown.

   This is the ONLY place the cap, the product handle and the Storefront token
   are defined. Every surface (announcement bar, home panel, PDP cross-sell,
   post-purchase, the Collective landing page) opts in with data attributes:

     [data-jseats]              text -> live open-seat count
     [data-jseats-cap]          text -> the cap (50)
     [data-jc-scope]            container; gets .is-closed when sold out
     [data-jc-open]             hidden once sold out
     [data-jc-closed]           shown  once sold out

   NOTE (2026-08-10): the close-date countdown was removed. Joining stays open
   with no deadline, so any leftover [data-jc-countdown] markup is hidden here
   (along with its separator) instead of ticking.

   Why not Liquid: Shopify caches variant.inventory_quantity at the data layer
   and it can serve a stale number for 10+ minutes. /products/x.js returns only
   `available` (bool). The Storefront API is the only live source. The token is
   the Headless channel PUBLIC token (safe to embed) with the inventory scope.
   ========================================================================== */
(function () {
  var CAP = 50,
    HANDLE = 'jab-collective',
    API = '/api/2025-01/graphql.json',
    TOKEN = '68d061cec5e50b5ea4c981f88b1b88bd',
    POLL_MS = 45000;

  var openSeats = null; // live count, once we know it

  function all(sel) {
    return Array.prototype.slice.call(document.querySelectorAll(sel));
  }

  /* Countdown markup may still exist on older sections. Hide it, plus the
     separator sitting right next to it, so nothing dangles. */
  function killCountdowns() {
    all('[data-jc-countdown], [data-jc-countdown-short], .jcd').forEach(function (el) {
      el.hidden = true;
      el.style.display = 'none';
      var sib = el.previousElementSibling;
      if (sib && /(^|_)sep($|_)|__sep/.test(sib.className || '')) {
        sib.hidden = true;
        sib.style.display = 'none';
      }
    });
  }

  /* ---------- paint ---------- */

  function paintSeats(n) {
    all('[data-jseats]').forEach(function (el) { el.textContent = n; });
    all('[data-jseats-cap]').forEach(function (el) { el.textContent = CAP; });
    /* legacy badge on the Collective landing page: "<dot>N of 50 seats open" */
    all('.jx .seats').forEach(function (el) {
      var dot = el.querySelector('.dot');
      el.textContent = '';
      if (dot) el.appendChild(dot);
      el.appendChild(document.createTextNode(n + ' of ' + CAP + ' seats open'));
    });
  }

  function paintState() {
    var closed = openSeats === 0;
    all('[data-jc-scope]').forEach(function (el) {
      el.classList.toggle('is-closed', closed);
    });
    all('[data-jc-open]').forEach(function (el) { el.hidden = closed; });
    all('[data-jc-closed]').forEach(function (el) { el.hidden = !closed; });
  }

  /* ---------- live count ---------- */

  function refresh() {
    try {
      /* the per-call alias makes each query body unique so Shopify's edge
         cache can't hand back a stale count during a fast sell-through */
      var alias = 'q' + Date.now();
      fetch(API, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': TOKEN
        },
        body: JSON.stringify({
          query: '{ ' + alias + ': product(handle:"' + HANDLE +
            '"){ variants(first:1){ nodes { quantityAvailable } } } }'
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var p = d && d.data && d.data[alias];
          var n = p && p.variants && p.variants.nodes[0];
          var q = n && typeof n.quantityAvailable === 'number' ? n.quantityAvailable : null;
          if (q === null) return;
          openSeats = Math.max(0, Math.min(CAP, q));
          paintSeats(openSeats);
          paintState();
        })
        .catch(function () { });
    } catch (e) { }
  }

  /* ---------- boot ---------- */

  function start() {
    var wanted = document.querySelector(
      '[data-jseats], [data-jc-scope], [data-jc-countdown], [data-jc-countdown-short], .jx .seats'
    );
    if (!wanted) return;

    killCountdowns();
    paintState();
    refresh();
    setInterval(function () { if (!document.hidden) refresh(); }, POLL_MS);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
